import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { VcsIntegrationUser } from "types/generated";

const IntegrationsVcsUsedByTableSpaceCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<VcsIntegrationUser>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsVcsUsedByTableSpaceCell;
